'use client';

import BackButton from '@/components/BackButton';
import { useRouter } from 'next/navigation';

export default function LoginBackButton() {
  const router = useRouter();
  return (
    <BackButton action={() => router.replace('/welcome')} router={router} />
  );
}
